<template>
  <div class="user-feedback">
    <UserFeedbackList
      v-if="viewMode === 'list'"
      :loading="loading"
      :loading-more="loadingMore"
      :is-mobile="isMobile"
      :display-list="displayList"
      :show-infinite-end-tip="showInfiniteEndTip"
      :current-page="currentPage"
      :total-pages="totalPages"
      :total-items="totalItems"
      :set-sentinel="setFeedbackSentinel"
      @open-submit="openSubmitDialog"
      @open-detail="openDetail"
      @previous-page="previousPage"
      @next-page="nextPage"
    />
    <UserFeedbackDetail
      v-else
      :detail="detail"
      :loading="detailLoading"
      @back="backToList"
    />
    <UserFeedbackSubmitDialog
      v-model:visible="submitVisible"
      :form="submitForm"
      :rules="submitRules"
      :loading="submitLoading"
      @close="closeSubmitDialog"
      @submit="handleSubmit"
    />
  </div>
</template>

<script setup>
import { useUserFeedback } from '@/features/user/composables/useUserFeedback'
import UserFeedbackList from '@/features/user/components/OperationArea/UserFeedbackList.vue'
import UserFeedbackDetail from '@/features/user/components/OperationArea/UserFeedbackDetail.vue'
import UserFeedbackSubmitDialog from '@/features/user/components/OperationArea/UserFeedbackSubmitDialog.vue'

const {
  viewMode,
  displayList,
  loading,
  loadingMore,
  detailLoading,
  detail,
  isMobile,
  setFeedbackSentinel,
  showInfiniteEndTip,
  currentPage,
  totalPages,
  totalItems,
  submitVisible,
  submitLoading,
  submitForm,
  submitRules,
  openDetail,
  backToList,
  openSubmitDialog,
  closeSubmitDialog,
  handleSubmit,
  nextPage,
  previousPage,
} = useUserFeedback()
</script>

<style scoped src="@/features/user/styles/operationArea/UserFeedback.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
